import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataProvinceListService } from "./services";

export const useProvinceListByIds = () => {
  const { mutateAsync: getListProvince } = useMutation({
    mutationKey: "masterDataProvinceListServiceOption",
    mutationFn: masterDataProvinceListService,
  });

  const getListProvincesByIds = useCallback(
    async (ids: number[], country: number) => {
      try {
        if (!ids?.length && !country) return {};

        const data = await getListProvince({ ids, countryId: country });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getListProvince]
  );

  return {
    getListProvincesByIds,
  };
};
